import { atom } from "jotai";
import { getDeliveries, getDeliveriesDownloads, getDeliveryFormSetup, getFieldAlias, getInventory, getLaydowns, getPartsByLaydown, getScopeDropdown, getScopeLaydownWise, getScopeListData, updateScope } from "../../services/logistics";

const LogisticsManagementAtom = atom({
    DeliveryData: [],
    laydownList: [],
    partList: [],
    aliasName: {},
    inventoryData: [],
    customFields: {},
    laydownWiseScope:[],
    currentLaydown:{},
    downloadData:{},
    scopeDropdownData: [],
    scopeListData: []
});

export const fetchScopeListData = atom(null, async (get, set, args) => {
  try {
    const res = await getScopeListData(args);
    if(res) {
      set(LogisticsManagementAtom, (prev) => ({ ...prev, scopeListData: res.data })); 
  }
  } catch (error) {
    console.error("❌ Error fetching deliveries:", error);
  }
});

export const fetchScopeDropdownData = atom(null, async (get, set, args, args2) => {
  try {
    const res = await getScopeDropdown(args, args2);
    if(res) {
      set(LogisticsManagementAtom, (prev) => ({ ...prev, scopeDropdownData: res.data })); 
  }
  } catch (error) {
    console.error("❌ Error fetching deliveries:", error);
  }
});

export const fetchDeliveriesAtom = atom(null, async (get, set) => {
    try {
      const res = await getDeliveries();
      if(res) {
        set(LogisticsManagementAtom, (prev) => ({ ...prev, DeliveryData: res.data })); 
    }
    } catch (error) {
      console.error("❌ Error fetching deliveries:", error);
    }
  });

  export const fetchDeliveriesDownloadAtom = atom(null, async (get, set) => {
    try {
      const res = await getDeliveriesDownloads();
      if(res) {
        set(LogisticsManagementAtom, (prev) => ({ ...prev, downloadData: res.data })); 
    }
    } catch (error) {
      console.error("❌ Error fetching deliveries:", error);
    }
  });

  export const fetchLaydownData = atom(null, async (get, set) => {
    try {
      const res = await getLaydowns();
      if(res) {
        set(LogisticsManagementAtom, (prev) => ({ ...prev, laydownList: res.data })); 
    }
    } catch (error) {
      console.error("❌ Error fetching deliveries:", error);
    }
  });

  export const fetchPartsList = atom(null, async (get, set, args) => {
    try {
      const res = await getPartsByLaydown(args);
      if(res) {
        set(LogisticsManagementAtom, (prev) => ({ ...prev, partList: res })); 
    }
    } catch (error) {
      console.error("❌ Error fetching deliveries:", error);
    }
  });

  export const fetchAliesData = atom(null, async (get, set, args1, args2) => {
    try {
      const res = await getFieldAlias(args1, args2);
      if(res) {
        set(LogisticsManagementAtom, (prev) => ({ ...prev, aliasName: res?.data })); 
    }
    } catch (error) {
      console.error("❌ Error fetching deliveries:", error);
    }
  });

  export const fetchInventoryData = atom(null, async (get, set, args1) => {
    try {
      const res = await getInventory(args1);
      if(res) {
        set(LogisticsManagementAtom, (prev) => ({ ...prev, inventoryData: res?.data })); 
    }
    } catch (error) {
      console.error("❌ Error fetching deliveries:", error);
    }
  });
  
  export const fetchCustomFields = atom(null, async (get, set, args1) => {
    try {
      const res = await getDeliveryFormSetup(args1);
      if(res) {
        set(LogisticsManagementAtom, (prev) => ({ ...prev, customFields: res?.data })); 
    }
    } catch (error) {
      console.error("❌ Error fetching deliveries:", error);
    }
  });

  export const UpdateScopeAtom = atom(null, async (_, set, args) => {
    await updateScope(args)
});
export const fetchScopeLaydownWiseAtom = atom(null, async (_, set, args) => {
    let res = await getScopeLaydownWise()
    if (res) {
        set(LogisticsManagementAtom, (prev) => ({ ...prev, laydownWiseScope: res?.data })); 
    }
});

export const setCurrentLaydownAtom = atom(null, async (_, set, args) => {
    set(LogisticsManagementAtom, (prev) => ({ ...prev, currentLaydown: args })); 
});
  
  export default LogisticsManagementAtom;
